import type { FileUpload } from '~kui/components/KUI/Core/File/Upload/types';

import type { FileFieldsFragment, PublicFileFieldsFragment } from '~/graphql/generated/graphql';

/** The leaf fields an upload needs, so both the public and the admin file fragments satisfy it. */
type PublicFileUpload = Pick<PublicFileFieldsFragment, 'id' | 'originalName' | 'publicUrl' | 'path' | 'mimeType' | 'size'>;

export const useV2CoreFileUpload = () => {
  const mapFragmentToUpload = (f: FileFieldsFragment): FileUpload => ({
    id: f.id,
    name: f.originalName,
    url: f.signedUrl ?? f.path,
    mimeType: f.mimeType,
    size: f.size,
    path: f.path,
  });

  const mapPublicFragmentToUpload = (f: PublicFileUpload): FileUpload => ({
    id: f.id,
    name: f.originalName,
    url: <string>f.publicUrl,
    path: f.path,
    mimeType: f.mimeType,
    size: f.size,
  });

  return {
    mapFragmentToUpload,
    mapPublicFragmentToUpload,
  };
};
